export const ClientState = {
  TrainingItem: 'eqms.training-item',
  AssignmentGroup: 'eqms.assignment-group',
  MyDocCollabs: 'eqms.my-doc-collabs',
  Curriculum: 'eqms.curriculum',
  Course: 'eqms.course',
  MyChangeRequest: 'eqms.my-change-requests',
  UserSelection: 'eqms.user-selection',
  MyDocApprovals: 'eqms.my-doc-approvals',
  MyQAReviews: 'eqms.my-qa-reviews',
  MyHardcopy: 'eqms.my-hard-copy',
  Delegates: 'eqms.delegate',
  MyFavorites: 'eqms.my-favorites',
  MyDocFormattings: 'eqms.my-doc-formattings',
  UserProfile: 'eqms.my-space.user-profile',
  ScopeManagement: 'eqms.eqms-scope-management',
  DocumentTemplates: 'eqms.document-templates-management',
  TrainingCourse: 'eqms.training-courses',
  DocumentDetails: 'eqms.document-details',
  MyDocReview: 'eqms.my-doc-review',
  MyAssignedAdmin: 'eqms.my-assign-admin',
  Home: 'eqms.my-space.home',
  Document: 'eqms.document',
  QuizAnswer: 'eqms.training.quizAnswers',
  ChangeControl: 'eqms.change-control',
  ChangeControlDetails: 'eqms.change-control-details',
  ActionItemRegister: 'eqms.action-item-register',
  TrainingStatus: 'eqms.training-status',
  MyClientSignatures: 'eqms.my-client-signatures',
  MyQuarantinedDocuments: 'eqms.my-quarantined-documents',
  RecordKPR: 'eqms.record-kpr'
};

export const CurrentState: any = {
  'eqms.training-item': '/eqms.training-item',
  'eqms.assignment-group': '/eqms.assignment-group',
  'eqms.my-doc-collabs': '/eqms.my-doc-collabs',
  'eqms.curriculum': '/eqms.curriculum',
  'eqms.course': '/eqms.course',
  'eqms.my-change-requests': '/eqms.my-change-requests',
  'eqms.user-selection': '/eqms.userSelection',
  'eqms.my-doc-approvals': '/eqms.my-doc-approvals',
  'eqms.my-qa-reviews': '/eqms.my-qa-reviews',
  'eqms.my-hard-copy': '/eqms.myhard-copy',
  'eqms.delegate': '/eqms.delegate',
  'eqms.my-favorites': '/eqms.my-favorites',
  'eqms.my-doc-formattings': '/eqms.my-doc-formattings',
  'eqms.my-space.user-profile': '/my-space/eqms.user-profile',
  'eqms.eqms-scope-management': '/eqms.eqmsScopeManagement',
  'eqms.document-templates-management': '/eqms.documentTemplatesManagement',
  'eqms.training-courses': '/training/eqms.courses/',
  'eqms.document-details': '/eqms.documentDetails/',
  'eqms.my-doc-review': '/eqms.my-doc-review',
  'eqms.my-assign-admin': '/eqms.my-assign-admin',
  'eqms.my-space.home': '/my-space/eqms.home',
  'eqms.document': '/eqms.document',
  'eqms.training.quizAnswers': '/training/eqms.quizAnswers/',
  'eqms.change-control': '/eqms.change-control',
  'eqms.change-control-details': '/eqms.changeControlDetails/',
  'eqms.action-item-register': '/eqms.action-item-register',
  'eqms.training-status': '/eqms.training-status',
  'eqms.my-client-signatures': '/eqms.my-client-signatures',
  'eqms.my-quarantined-documents': '/eqms.my-quarantined-documents',
  'eqms.record-kpr': '/eqms.record-kpr'
};
